import React from 'react';
import PropTypes from 'prop-types';
import styles from './Station.module.css';

const Station = props => {
  const { active, flexBasis, station, onClick } = props;
  return (
    <div
      onClick={() => onClick && onClick(station)}
      className={styles.container}
      style={{ borderColor: active ? '#ad0028' : '#FFF', width: flexBasis }}>
      <span className={styles.tableNum}>{station.name}</span>
    </div>
  );
};

export default Station;

Station.propTypes = {
  active: PropTypes.bool.isRequired,
  flexBasis: PropTypes.any,
  onClick: PropTypes.func.isRequired,
};

Station.defaultProps = {
  active: false,
  flexBasis: '30%',
  onClick: () => { },
};
